import { createRefPath, createRefPath_client } from "global/firestoreData/appData/appRefPaths";
import { dispatchConfirmationTypes, grts, responseHandlers, responseReducers } from "./reducerHelpers/dispatchProps";
import _, { assign } from 'lodash'
import { getGallery_clientProfiles } from "global/storage/storageItems";
import { gEnums } from "global/enums/globalEnums";
import { currentHelpers } from "global/redirection/current";
import { _currentUserIdProp } from "./AppUserReducer";

export const rts = {
  // handleInit_appUsers: 'handleInit_appUsers',
  // handleSet_profiles: 'handleSet_profiles',
  handleSet_eventAppUsers: 'handleSet_eventAppUsers',
  handleCreate_clientProfileUrls: 'handleCreate_clientProfileUrls',
  handleUpdate_tempAccess: 'handleUpdate_tempAccess',
  ...grts
}

export const appUsersReducerInitialState = (initState) => {
  return { ...initState }
};

export const appUsersReducer = (state, action) => {

  const { mainStorage, pathViews, database_fns } = state
  const { type, dispatch } = action

  switch (type) {

    // case rts.handleInit_appUsers:
    //   return { ...state }

    case rts.handleSet_eventAppUsers:
      return { ...state, eventAppUsers: action.eventAppUsers }

    case rts.handleCreate_clientProfileUrls:
      // called from AppDataSidebar ONLY
      handleCreateClientProfileUrls(database_fns, action.aps_global, action.appUserCollection, action.appDataDocuments, action.callback, mainStorage, pathViews)
      return state

    case rts.handleUpdate_tempAccess:
      const _scanData = JSON.parse(action.scanData)
      const { docId, appUserId, golferKey, firstName, lastName } = _scanData ?? {}
      if (docId) {
        if (storedUserId && golferKey) {
          const refPath = createRefPath(['_accessTemp', docId])
          const dataToUpdate = {
            [appUserId]: {
              allowed: true,
              firstName,
              lastName,
              golferKey
            }
          }
          database_fns.doc_set(refPath, dataToUpdate, true)
        }
      }
      return { ...state }

    case rts.handleCloseConfirmation:
    case rts.handleFunctionResponse:
    case rts.handleStartUpdate:
    case rts.updateError:
    case rts.updateSuccess:
    case rts.updateSuccessAlt:
      return responseReducers(state, action, { dispatch, dispatchConfirmationType: dispatchConfirmationTypes.closeAfterConfirmation })

    default:
      return { ...state }
  }
}

export const appUsersHandlers = (dispatch) => {
  return {
    handleUpdate_tempAccess: (scanData) => { dispatch({ type: rts.handleUpdate_tempAccess, dispatch, scanData }) },
    handleInit_appUsers: (appUserCollections) => { dispatch({ type: rts.handleInit_appUsers, dispatch, appUserCollections }) },
    handleSet_eventAppUsers: (eventAppUsers) => { dispatch({ type: rts.handleSet_eventAppUsers, dispatch, eventAppUsers }) },
    handleCreate_clientProfileUrls: (aps_global, appUserCollection, appDataDocuments, callback) => { dispatch({ type: rts.handleCreate_clientProfileUrls, dispatch, aps_global, appUserCollection, appDataDocuments, callback }) },
    ...responseHandlers(dispatch)
  }
}

const handleCreateClientProfileUrls = async (database_fns, aps_global, appUserCollection, appDataDocuments, callback, mainStorage, pathViews) => {

  const cb = async (a) => {
    const { galleryItems } = a
    if (database_fns) {
      const reff = createRefPath_client(pathViews, ['profileGallery', 'galleryItems'])
      const xxx = {}
      _.forEach(galleryItems, (item, itemKey) => {
        const { urls, customMetadata } = item
        xxx[itemKey] = {
          urls,
          customMetadata
        }
      })
      console.log('reff', reff, xxx)
      await database_fns.set_doc(reff, xxx, false)
      callback('done')
    }
  }
  const { storageOptions } = aps_global ?? {}
  const { clientStorageImageCollections } = storageOptions ?? {}
  let allEmails = []
  _.forEach(clientStorageImageCollections, (imageCollection) => {
    const appDataDocument = appDataDocuments?.[imageCollection]
    const emails = appDataDocument ? _.map(_.filter(appDataDocument, 'email'), 'email') : [];
    allEmails = _.concat(allEmails, emails)
  })
  getGallery_clientProfiles(mainStorage, pathViews, appUserCollection, null, cb, gEnums.storageLocationTypes.clientProfiles, allEmails)
}